import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { FileSelector, Input, Select } from "components/base/Form";
import { InlineSpinner } from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import useFileUploader from "hooks/useFileUploader";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CREATE_SUPPLIER } from "./graphql";

const SupplierForm = ({ hide }) => {
  const [nickName, setNickName] = useState("");
  const [email, setEmail] = useState("");
  const [supplierClass, setSupplierClass] = useState("1");
  const [nda, setNda] = useState(null);
  const [initialPassword, setInitialPassword] = useState(
    Math.random().toString(36).slice(-8), // Generate a random 8-character password
  );
  const navigate = useNavigate();

  const { isUploading, handleFileUpload } = useFileUploader((urls) => {
    setNda(urls[0]);
  });
  const [create, createRes] = useMutation(CREATE_SUPPLIER, {
    variables: {
      nickName,
      email,
      initialPassword,
      supplierClass,
      signedNdaFileUrl: nda,
    },
    onError(error) {
      Alert("error", parseError(error));
    },
    onCompleted(res) {
      Alert("success", "Supplier created successfully");
      hide();
      navigate(`/suppliers/onboarding/${res.createSupplier.supplier.id}`);
    },
    refetchQueries: ["FETCH_SUPPLIERS"],
  });

  function validateForm() {
    if (!nickName) {
      Alert("error", "Please enter a nick name for the supplier.");
      return false;
    }
    if (!email) {
      Alert("error", "Please enter an email for the supplier.");
      return false;
    }
    if (!initialPassword) {
      Alert("error", "Please enter an initial password for the supplier.");
      return false;
    }

    if (["1", "3"].includes(supplierClass) && !nda) {
      Alert(
        "error",
        "Please upload the signed NDA document for this supplier.",
      );
      return false;
    }

    return true;
  }

  function createHandler() {
    if (validateForm()) create();
  }

  return (
    <div>
      <div className="-mx-2">
        <table>
          <tbody>
            <tr>
              <td>
                <label>Nick Name: </label>
              </td>
              <td className="w-full">
                <Input
                  className="w-full"
                  placeholder="For example: CREATIVEHOME/创意达"
                  value={nickName}
                  onChange={(e) => setNickName(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Class: </label>
              </td>
              <td>
                <Select
                  value={supplierClass}
                  onChange={(e) => setSupplierClass(e.target.value)}
                >
                  <option value="1">1级 - 核心供应商(NDA)</option>
                  <option value="2">2级 - 配件产品供应商</option>
                  <option value="3">3级 - 周边产品供应商(NDA)</option>
                </Select>
              </td>
            </tr>
            <tr>
              <td className="align-baseline">
                <label>Signed NDA</label>
              </td>
              <td className="align-baseline">
                {nda && (
                  <div>
                    <a
                      href={nda}
                      target="_blank"
                      rel="noreferrer"
                      className="underline text-sm"
                    >
                      {nda}
                    </a>
                  </div>
                )}

                {isUploading ? (
                  <div className="flex relative">
                    <InlineSpinner size={14} text={null} />
                  </div>
                ) : (
                  <FileSelector
                    disabled={isUploading}
                    className="text-sm mt-2"
                    title="Upload Signed NDA Document"
                    onChange={(e) => {
                      const files = [...e.target.files];
                      handleFileUpload(files);
                      e.target.value = null;
                    }}
                  />
                )}

                <div className="text-xs opacity-70 mt-1">
                  You can download the NDA template{" "}
                  <a
                    href="https://qiniu-waboba.cors.tech/NTBkODYyYzBiZjYw.docx"
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-500 underline"
                  >
                    here
                  </a>
                  .
                </div>
              </td>
            </tr>
            <tr>
              <td className="align-baseline">
                <label>Email: </label>
              </td>
              <td>
                <Input
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full"
                  placeholder="Email"
                />
                <div className="text-xs opacity-70 mt-1 mx-1">
                  WIS will use this email to create a new account for the
                  supplier. They will use this account to access Supplier
                  Portal.
                </div>
              </td>
            </tr>
            <tr>
              <td className="align-baseline">
                <label>Initial Password: </label>
              </td>
              <td>
                <Input
                  value={initialPassword}
                  onChange={(e) => setInitialPassword(e.target.value)}
                  className="w-full"
                  placeholder="Initial Password"
                />
                <div className="text-xs opacity-70 mt-1 mx-1">
                  This password will be used to create the supplier's account.
                  They can change it later.
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <hr />

      <div className="text-sm">
        <Button primary onClick={createHandler} loading={createRes.loading}>
          Create Supplier
        </Button>
      </div>
    </div>
  );
};

export default SupplierForm;
